import { PromiseCancelable } from 'common/module/promise/cancelable';
import { PromiseCancelableInterface } from 'common/module/promise/cancelable.interface';

export function PromiseCancelableFactory<T>(promise: Promise<T>): PromiseCancelableInterface<T> {
  return new PromiseCancelable<T>(promise);
}
